import React from 'react';
import './company.css';

export default function Company({ logo, name, period, children }) {
    return (
        <div className="company">
            <div className="company-header">
                <div className="company-info">
                    {logo && (
                        <div className="company-logo">
                            <img src={logo} alt={`${name} logo`} decoding="async" />
                        </div>
                    )}
                    <span className="text-company-title">{name}</span>
                </div>
                <span className="text-period">{period}</span>
            </div>
            {children && (
                <div className="company-content">
                    {children}
                </div>
            )}
        </div>
    );
}
